module.exports = __webpack_public_path__ + "img/img.2d013d3e.png";